<!--//jeb cool loading spinner-->
<div *ngIf="loading" class="dashboard text-center">
  Loading Digital Marketing Dashboard...
</div>
<div *ngIf="!loading" class="dashboard white-background">
  <!-- Dashboard Navigation Menu -->
  <nav class="inverse navbar navbar-fixed-top">
    <div class="navbar-header">
      <button type="button" class="navbar-toggle" data-toggle="collapse" data-target=".dashboard-navbar">
        <span class="sr-only">Toggle navigation</span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </button>

      <div class="dashboard-navbar navbar-collapse collapse">
        <ul class="nav navbar-nav">
          <li class="dropdown" *ngIf="user.isEmployee">
            <a class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true"
              aria-expanded="false">
              <i class="glyphicon glyphicon-star employee"></i>
              Admin
              <span class="caret"></span>
            </a>
            <ul class="dropdown-menu">
              <li>
                <a routerLink="/" (click)="setMimicClientId(1)" title="Employee Dashboard">
                  <i class="glyphicon glyphicon-th-list"></i>
                  Employee Dashboard
                </a>
              </li>
              <li role="separator" class="divider"></li>
              <li>
                <a routerLink="/" (click)="viewPreviousClient()" title="Previous Client">
                  <i class="glyphicon glyphicon-arrow-left"></i>
                  Mimic Previous Client
                </a>
              </li>
              <li>
                <a routerLink="/" (click)="viewNextClient()" title="Next Client">
                  <i class="glyphicon glyphicon-arrow-right"></i>
                  Mimic Next Client
                </a>
              </li>
              <li role="separator" class="divider"></li>
              <li *ngFor="let mimicClient of clientService.allClients; let number = index">
                <a *ngIf="!mimicClient.isMatrixTools" routerLink="/" (click)="setMimicClientId(mimicClient.id)" title="Select Client">
                  {{ number }}. {{ mimicClient.name }}
                </a>
              </li>
            </ul>
          </li>
          <li class="dropdown" *ngIf="dashboardService.client && dashboardService.client.websites.length > 1">
            <a class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true"
              aria-expanded="false">
              <i class="glyphicon glyphicon-globe"></i>
              Websites
              <span class="caret"></span>
            </a>
            <ul class="dropdown-menu">
              <li *ngFor="let website of dashboardService.client.websites">
                <a (click)="setWebsite(website.domain)" title="Select Website" class="website-list">
                  <img id="select-website-icon" *ngIf="website.icon" class="circle icon" src="{{ website.icon }}" />
                  {{ website.domain }}
                </a>
              </li>
            </ul>
          </li>
          <li class="dropdown" *ngIf="dashboardService.client">
            <a class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true"
              aria-expanded="false">
              <i class="glyphicon glyphicon-dashboard"></i>
              Dashboards
              <span class="caret"></span>
            </a>
            <ul class="dropdown-menu">              
              <li>
                <a [class.disabled]="dashboardService.changeLogErrors" routerLink="/change-log">
                  <i *ngIf="dashboardService.changeLogErrors" class="glyphicon glyphicon-ban-circle error"></i>
                  <span [class.line-through]="dashboardService.changeLogErrors">Change Log</span>
                </a>
              </li>
              <li>
                <a [class.disabled]="!dashboardService.client.isWebsiteEnabled" routerLink="/website">
                  <i *ngIf="!dashboardService.client.isWebsiteEnabled" class="glyphicon glyphicon-ban-circle error"></i>
                  <span [class.line-through]="!dashboardService.client.isWebsiteEnabled">Website</span>
                </a>
              </li>
              <li role="separator" class="divider"></li>
              <li>
                <a [class.disabled]="!dashboardService.client.isSeoEnabled" routerLink="/seo">
                  <i *ngIf="!dashboardService.client.isSeoEnabled" class="glyphicon glyphicon-ban-circle error"></i>
                  <span [class.line-through]="!dashboardService.client.isSeoEnabled">Search Engine Optimization</span>
                </a>
              </li>
              <li>
                <a [class.disabled]="!dashboardService.client.isSmmEnabled" routerLink="/smm">
                  <i *ngIf="!dashboardService.client.isSmmEnabled" class="glyphicon glyphicon-ban-circle error"></i>
                  <span [class.line-through]="!dashboardService.client.isSmmEnabled">Social Media</span>
                </a>
              </li>
            </ul>
          </li>
          <li class="dropdown" *ngIf="dashboardService.client">
            <a class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true"
              aria-expanded="false">
              <i class="glyphicon glyphicon-cog"></i>
              Settings
              <span class="caret"></span>
            </a>
            <ul class="dropdown-menu">
              <li>
                <a [class.disabled]="dashboardService.changeLogErrors" routerLink="/change-log/settings">
                  <i *ngIf="dashboardService.changeLogErrors" class="glyphicon glyphicon-ban-circle error"></i>
                  <span [class.line-through]="dashboardService.changeLogErrors">Change Log</span>
                </a>
              </li>
              <li>
                <a [class.disabled]="!dashboardService.client.isWebsiteEnabled" routerLink="/website/settings">
                  <i *ngIf="!dashboardService.client.isWebsiteEnabled" class="glyphicon glyphicon-ban-circle error"></i>
                  <span [class.line-through]="!dashboardService.client.isWebsiteEnabled">Website</span>
                </a>
              </li>
              <li role="separator" class="divider"></li>
              <li>
                <a [class.disabled]="!dashboardService.client.isSeoEnabled" routerLink="/seo/settings">
                  <i *ngIf="!dashboardService.client.isSeoEnabled" class="glyphicon glyphicon-ban-circle error"></i>
                  <span [class.line-through]="!dashboardService.client.isSeoEnabled">Search Engine Optimization</span>
                </a>
              </li>
              <li>
                <a [class.disabled]="!dashboardService.client.isSmmEnabled" routerLink="/smm/settings">
                  <i *ngIf="!dashboardService.client.isSmmEnabled" class="glyphicon glyphicon-ban-circle error"></i>
                  <span [class.line-through]="!dashboardService.client.isSmmEnabled">Social Media</span>
                </a>
              </li>
            </ul>
          </li>
          <li class="dropdown">
            <a class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true"
              aria-expanded="false">
              <i class="glyphicon glyphicon-user"></i>
              {{ user.email }}
              <span class="caret"></span>
            </a>
            <ul class="dropdown-menu">
              <li><a href="#">Change Password</a></li>
              <li><a (click)="logOut()">Log Out</a></li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </nav>

  <router-outlet></router-outlet>

</div>
